import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import React, { useEffect } from 'react';
import DialogActions from '@mui/material/DialogActions';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    AutoLink,
    BlockQuote,
    Bold,
    ClassicEditor,
    Essentials, FontFamily, FontSize,
    Heading,
    Indent,
    Italic,
    Link, LinkEditing, LinkUI,
    List, MediaEmbed,
    Mention,
    Paragraph, Table,
    Undo,
} from 'ckeditor5';
import { Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SaveButton from '../Common/SaveButton';
import { useAsyncCallback } from '../../hooks/useAsyncCallback';

export default function EditCommentModal (props) {
    const {open, cancel, comment, setComment, save, originalValue, useEditor} = props;
    const { t } = useTranslation();

    const { run: handleSave, loading: saving } = useAsyncCallback(async () => {
        await save();
    });

    useEffect(() => {

    }, []);

    return (
        <Dialog
            open={open}
            sx={{'& .MuiDialog-paper': {width: '100%', maxHeight: 435}}}
            >
            <DialogTitle>{t('editComment.title')}</DialogTitle>
            <DialogContent dividers>
                {useEditor ?
                    <CKEditor
                        editor={ClassicEditor}
                        style={{height: '400px', width: '100%'}}
                        config={{
                            licenseKey: 'GPL',
                            toolbar: {
                                items: [ 'heading',
                                    '|',
                                    'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
                                    '|',
                                    'bold', 'italic', 'link', 'bulletedList', 'numberedList',
                                    '|',
                                    'blockQuote', 'insertTable', 'mediaEmbed', 'codeBlock',
                                    '|',
                                    'todoList', 'outdent', 'indent', 'undo', 'redo' ]
                            },
                            plugins: [
                                Bold, Essentials, Italic, Mention, Paragraph, Undo, Link, List, Heading, Indent, MediaEmbed, Table, FontFamily, FontSize, BlockQuote, AutoLink, LinkEditing, LinkUI
                            ],
                            link: {
                                addTargetToExternalLinks: true,
                            },
                            mediaEmbed: {
                                previewsInData: true,

                            }
                        }}
                        data={comment}
                        onChange={(event, editor) => {
                            setComment(editor.getData());
                        }}
                    />
                :
                <TextField style={{ width: '100%' }} value={comment} onChange={(event) => {
                        setComment(event.target.value);
                        }
                    } />
                    }
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => cancel()} disabled={saving}>{t('common.cancel')}</Button>
                <SaveButton loading={saving} onClick={handleSave} disabled={originalValue === comment}>{t('common.save')}</SaveButton>
            </DialogActions>
        </Dialog>
    )
}
